/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { tv } from 'tailwind-variants';
import { findComponent } from 'lib/utils/object-utils';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'w-full'
        ],
        articleMainContent: [
            'flex',
            ' flex-col'
        ]
    },
    variants: {
        isArticleContent: {
            true: {
                articleMainContent: [
                    'pt-0',
                    'gap-margin-macro'
                ]
            },
            false: {
                articleMainContent: [
                    'py-general-spacing-margin-y',
                    'gap-padding-loose'
                ]
            }
        }
    }
});
const ArticleMain = (props)=>{
    const isEditing = useIsEditing();
    const { rendering } = props;
    const { RenderingIdentifier } = props?.params || {};
    const context = useSitecoreContext();
    const itemId = context?.sitecoreContext?.itemId?.toUpperCase()?.replace(/-/g, '');
    const { base, articleMainContent } = TAILWIND_VARIANTS();
    const isArticleContent = findComponent(props.rendering, 'ArticleContent');
    const role = isArticleContent ? 'none' : 'tabpanel';
    return /*#__PURE__*/ _jsxs("div", {
        "data-component": "authorable/shared/layout/article-main",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        className: base(),
        ...getTestProps(`component-article-main-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: "custom-article-top-content-header",
                rendering: rendering
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: articleMainContent({
                    isArticleContent: isArticleContent?.length > 0
                }),
                id: `articletab-content-${itemId}`,
                role: role,
                "aria-labelledby": role === 'tabpanel' ? `articletab-${itemId}` : undefined,
                children: [
                    /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                        name: "custom-article-top-content-main",
                        rendering: rendering
                    }),
                    /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                        name: "custom-article-main-content",
                        rendering: rendering
                    }),
                    /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                        name: "custom-article-bottom-content",
                        rendering: rendering
                    })
                ]
            })
        ]
    });
};
export const Default = withStandardComponentWrapper(ArticleMain, false);
